// 查询字典(生效)数据
export const QRY_ATTR_LIST = '/myfinance/attrSpec/findList'

//查询字典数据
export const QRY_ATTR_LIST_BY_PARID = '/myfinance/attrSpec/qryAttrSpecByParId'

//账本保存地址
export const FINANCE_SAVE_URL = '/myfinance/finance/save'

//登录地址
export const LOGIN_URL = '/myfinance/checkUser'

//查询统计信息
export const QRY_FIN_REPORT = 'myfinance/finance/qryFinReport'

//查询账单列表
export const QRY_FIN_LIST = 'myfinance/finance/qryFinList'

//查询要修改的账单数据
export const QRY_FIN_DETAIL = 'myfinance/finance/qryFinDetail'

//查询要修改的账单数据
export const QRY_FIN_DAY_COUNT = 'myfinance/finance/qryDayCount'

//按日期查询当天的收支情况
export const QRY_FIN_DAY_INFO = 'myfinance/finance/qryDayInfo'

//按月查询当天的收支情况
export const QRY_FIN_MONTH_INFO = 'myfinance/finance/qryMonthInfo'

//查询通知信息
export const QRY_NOTICE_INFO = 'myfinance/notice/qryNoticeInfo'

//按月,归属查询统计数据
export const QRY_FIN_MONTH_BELONG_PERCENT = 'myfinance/finance/qryBelongPercent'

//按月,分类查询统计数据
export const QRY_FIN_MONTH_SORT_PERCENT = 'myfinance/finance/qrySortPercent'
//按分类查询分类明细统计数据
export const QRY_FIN_SORT_DETAIL_PERCENT = 'myfinance/finance/qrySortDetailPercent'

//按月,归属统计聊天记录
export const QRY_REC_MONTH_COUNT = 'myfinance/recMonthCount/qryRecMonthCount'

//分类查询统计数据
export const QRY_REC_SORT_COUNT = 'myfinance/recRecordsCount/qryRecRecordsCount'

//查询热力图
export const QRY_REC_WEEK_HOUT_COUNT = 'myfinance/recWeekHourCount/qryWeekHourCount'

//查询热力图
export const QRY_SORT_AMT_LIST = 'myfinance/finance/qrySortAmtList'

//零用钱保存地址
export const POCKET_MONTY_SAVE_URL = '/myfinance/pocketMoneyDetail/save'

//零用钱保存地址
export const QRY_POCKET_MONTY_URL = '/myfinance/pocketMoney/qryPocketMoney'

//删除账本数据
export const FINANCE_DEL_URL = '/myfinance/finance/remove'

//高级统计
export const QRY_FIN_ADVANCE_COUNT = '/myfinance/finance/advanceCount'

//轧账接口
export const FIN_SETTLEMENT_ACCOUNT = '/myfinance/finance/settlementAccount'

//查询标签接口
export const FIN_QRY_TAGS = '/myfinance/attrSpec/qryTags'

//处理标签接口
export const FINANCE_MOD_TAG = '/myfinance/finTagRel/modTag'

//查询标签接口
export const MOD_SYS_TAGS = '/myfinance/attrSpec/modSysTag'

// 查询字典(生失效)数据
export const QRY_ATTR_ALL_LIST = '/myfinance/attrSpec/findAllList'

//登录地址
export const CHECK_TOKEN_URL = '/myfinance/checkToken'

//记录加班地址
export const RECORD_WORK_OVERTIME_URL = '/myfinance/workOvertime/recordWorkOvertime'

//按月查询当天的收支情况
export const QRY_FIN_YEAR_INFO = "myfinance/finance/qryYearInfo"

//按年,归属查询统计数据
export const QRY_FIN_YEAR_BELONG_PERCENT = 'myfinance/finance/qryBelongPercent'

//按年,分类查询统计数据
export const QRY_FIN_YEAR_SORT_PERCENT = 'myfinance/finance/qrySortPercent'

//查询在途列表
export const QRY_TRANS_FIN_LIST = 'myfinance/transFinance/initTransFinance'

//保存在途账单
export const TRANS_FINANCE_SAVE_URL = 'myfinance/transFinance/save'

//查询在途列表
export const QRY_TRANS_FIN_DETAIL_LIST = 'myfinance/transFinance/qryTransFinDetailList'

//删除账本明细数据
export const TRANS_FIN_DETAIL_DEL_URL = 'myfinance/transFinance/remove'

//查询分期报表数据
export const QRY_CREDIT_REPORT_LIST = 'myfinance/creditReport/qryCreditReportList'

//修改分期账单状态
export const  UPD_CREDIT_REPORT_STATUS = 'myfinance/creditReport/doFinish'

//保存分类明细数据
export const SAVE_SORT_DETAIL = 'myfinance/attrSpec/saveSortDetail'

//清空缓存
export const CLEAR_REDIS = 'myfinance/redis/clearRedis'

//翻转状态
export const REVERSAL_STATUS = 'myfinance/attrSpec/reversalStatus'

//置顶数据
export const BACK_TOP = 'myfinance/attrSpec/backTop'

//向下置换数据
export const BACK_DOWN = 'myfinance/attrSpec/backDown'

//关闭通知信息
export const CLOSE_NOTICE_INFO = 'myfinance/notice/closeNotice'

//推送快应用消息
export const PUSH_QUICK_MSG = 'myfinance/quickAppPush/pushQuickMsg'

//根据分期账单id查询分期明细
export const QRY_CREDIT_DETAIL = 'myfinance/creditReport/qryFinanceDetailByRptId'

//重新计算分期账单
export const AGAIN_DO_CREDIT_REPORT = 'myfinance/creditReport/againDoCreditReport'

//查询租房信息
export const QRY_RENT_LIST = "myfinance/rent/rentList"

//查询宝记列表
export const QRY_BAO_REC_LIST = "myfinance/baoRecords/qryBaoRecList"

//保存宝记
export const SAVE_BAO_REC = 'myfinance/baoRecords/saveBaoRec'

//删除宝记
export const DEL_BAO_REC = 'myfinance/baoRecords/delBaoRec'

//保存周期性宝记
export const SAVE_CYCLE_BAO_REC = 'myfinance/baoRecords/saveCycleBaoRec'

//删除宝记
export const DEL_CYCLE_BAO_REC = 'myfinance/baoRecords/delCycleBaoRec'

//查询分期配置
export const QRY_CREDIT_CFG_LIST = 'myfinance/creditCfg/getCreditCfgList'

//手工出账
export const QRY_CREDIT_AGAIN_BTN = 'myfinance/creditCfg/againBtnCreditReport'

// 查询分类与标签对应关系
export const QRY_TYPES_TAGS_LIST = 'myfinance/typesTagsRel/typeTagsList'

// 增加保存界面
export const SAVE_TYPES_TAGS = 'myfinance/typesTagsRel/save'